var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRightBorderIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 11.9961L2 11.9961C0.895431 11.9961 7.8281e-08 11.1007 1.74846e-07 9.99609L8.74035e-07 1.99829C9.706e-07 0.893724 0.895432 -0.00170683 2 -0.00170674L9 -0.00170612L9 2.07245L3 2.07245C2.44772 2.07245 2 2.52017 2 3.07245L2 9.11392C2 9.66621 2.44772 10.1139 3 10.1139L9 10.1139L9 11.9961Z",
    fill: "#D8D8D8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 10C12 11.1046 11.1046 12 10 12L10 -1.74846e-07C11.1046 -7.8281e-08 12 0.895431 12 2L12 10Z",
    fill: "#707070"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightBorderIcon);
export default __webpack_public_path__ + "static/media/right-border-icon.bb598a99ba610985b3c250638b9966f3.svg";
export { ForwardRef as ReactComponent };